import Config from "../../config/index";
import axios from "axios/index";
import {flashMessage} from "redux-flash";
import {setLocale} from "react-redux-i18n";
import {setLanguages} from "./language";
import jwtDecode from 'jwt-decode';

export function pingMe() {
    const request = Config.api.endpoint + 'api/user/ping';

    return (dispatch) => {
        dispatch({
            type: 'USER_PING_LOADING'
        });

        return axios.post(request, {}, Config.getApiConfig()).then(response => {
            //TODO get if we have update the interface
            // if (response.data) {
            //     // dispatch({
            //     //     type: 'USER_PING_SUCCESS',
            //     //     payload: "nots sure"
            //     // });
            // } else {
            //     // dispatch({
            //     //     type: 'USER_PING_FAILURE',
            //     //     payload: {data:""}
            //     // });
            // }
        }).catch(error => {
            if (Config.getToken()) {
                dispatch(logout());
                dispatch(flashMessage('Authorization outdated! Please re-login into system! Page will refresh in 20 seconds..', {
                    timeout: 0,
                    props: {type: 'error'}
                }));
                setTimeout(function () {
                    window.location.reload();
                }, 20000);
            } else {
                dispatch(logout());
            }
            return error;
        });
    }

}

export function ssoGetToken(ssoId) {
    const request = Config.api.endpoint + 'api/UserSso/token/' + ssoId;

    return (dispatch) => {
        dispatch({
            type: 'SSO_GET_TOKEN_LOADING'
        });

        return axios.get(request, Config.getApiConfig()).then(response => {
            if (response.data) {
                Config.setToken(response.data.token);

                let decoded = jwtDecode(response.data.token);

                Config.setUser(decoded);

                Config.set("csodSession", Config.getCurrentCsodSessionGuid());

                dispatch({
                    type: 'USER_LOGIN_SUCCESS',
                    payload: decoded
                });

                dispatch(setLocale(Config.language));

                dispatch(setLanguages());

                dispatch({
                    type: 'SSO_GET_TOKEN_SUCCESS',
                    payload: response.data
                });

                return response;

            } else {
                dispatch(logout());

                dispatch({
                    type: 'SSO_GET_TOKEN_FAILURE',
                    payload: null
                });
                return response;
            }
        }).catch(error => {
            dispatch(logout());

            dispatch({
                type: 'SSO_GET_TOKEN_FAILURE',
                payload: error
            });
        });
    }
}

export function login(values, frontendToken) {
    const {username, password} = values;
    const request = Config.api.endpoint + 'api/user/login';

    const formData = {
        userName: username,
        password: password
    };

    return (dispatch) => {
        dispatch({
            type: 'USER_LOGIN_SUBMITTING'
        });

        return axios.post(request, formData).then(response => {
            if (response.data) {

                Config.setToken(response.data.token);
                Config.setUser(jwtDecode(response.data.token));

                dispatch({
                    type: 'USER_LOGIN_SUCCESS',
                    payload: {
                        ...jwtDecode(response.data.token),
                        userName: username,
                        loggedIn: true,
                    }
                });

                dispatch(setLocale(Config.language));
                dispatch(setLanguages());

                if (!frontendToken) {
                    dispatch(flashMessage('Login successful!', {timeout: 6000, props: {type: 'success'}}));
                    window.location.reload();
                }

                return Promise.resolve(true);
            } else {
                dispatch({
                    type: 'USER_LOGIN_FAILURE',
                    payload: {
                        userName: username
                    }
                });
            }
        }).catch(error => {
            dispatch({
                type: 'USER_LOGIN_FAILURE',
                payload: error
            });

            Config.clearStorage();

            return error;
        });
    }
}

export function resetAllState() {
    return (dispatch) => {
        return Promise.resolve(true);
    }
}

export function logout() {
    return (dispatch) => {
        Config.clearStorage();

        window.location.reload();

        return Promise.resolve(true);
    }
}


// WEBPACK FOOTER //
// ./src/core/store/actions/user.js